<template>
  <div class="notification is-danger">
    <button class="delete" @click='$emit("clear")'></button>
    <ul>
      <li v-for='message in messages' :key='message'>{{ message }} </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ErrorNotification',

  props: {
    messages: {
      type: Array,
      required: true
    }
  }
}
</script>
